import React, { PureComponent } from "react";
import { Table, Link, Select } from 'element-react';
import Slider from "react-slick";
import leftImg from "images/index/serviceCenter_cont_left_img.png";
import serviceCenterImg01 from "images/index/serviceCenterImg01.png";
import serviceCenterImg02 from "images/index/serviceCenterImg02.png";
import serviceCenterImg03 from "images/index/serviceCenterImg03.png";
import serviceCenterImg04 from "images/index/serviceCenterImg04.png";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.scss";
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "transparent", width: "50px", height: "50px", top: "138px", right: "-54px", textAlign: "left", borderRadius: "50%" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "transparent", width: "50px", height: "50px", top: "138px", left: "-54px", textAlign: "right", borderRadius: "50%" }}
      onClick={onClick}
    />
  );
}
export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }


  componentDidMount() {
    const { BMap } = window;
    let map = new BMap.Map("map"); //创建Map实例
    var point = new BMap.Point(110.287258, 20.019071); //定义一个中心点坐标
    map.centerAndZoom(point, 11); //设定地图的中心点和坐标并将地图显示在地图容器中
    var marker = new BMap.Marker(point); // 创建标注
    map.addOverlay(marker); // 将标注添加到地图中
  }

  render() {
    const settings = {
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 2,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    return (
      <div className="searchResult" style={{ backgroundColor: '#fff' }}>
        <div className="serviceCenter container">
          <div className="serviceCenter_cont clear">
            <div className="serviceCenter_cont_left">
              <img src={leftImg} />
              <div className="serviceCenter_cont_left_txt">
                <div>儋州市退役军人服务中心</div>
                <div>
                  <span>电话：0771-2638860</span>
                  <span>地址：海南省儋州市中兴大道财政局旁</span>
                </div>
                <div>工作时间：上午（9:00~12:00） 下午（14:30-18：00）</div>
              </div>
            </div>
            <div className="serviceCenter_cont_right">
              <div className="cont_title"><span>服务中心介绍</span></div>
              <div className="title">
                <i></i>
                <span>概况</span>
              </div>
              <div className="txt" style={{ marginBottom: '40px' }}>退役军人服务中心主要承担退役军人政策宣传和信息管理、就业创业扶持、优抚帮扶、走访慰问、信访接待、权益维护等事务性、服务性、保障性等工作。将搭建起广大退役军人的政策咨询的窗口、感情联络的纽带、信息沟通的渠道、帮扶援助的平台，加强三亚市退役军人工作力量，进一步提升退役军人服务保障水平，解决退役军人政策落实和服务保障问题。</div>
              <div className="title">
                <i></i>
                <span>概况</span>
              </div>
              <div className="txt">
                公交：26、47、302、332、333、384、608、641、718、751、913、944支线、982路民主二号站；
              </div>
              <div className="txt">
                地铁：二号线望江站
              </div>
            </div>
          </div>

          <div className="traffic">
            <div className="cont_title"><span>交通路线</span></div>
            <div id="map" style={{ width: "1200px", height: "260px" }}></div>
          </div>

          <div className="exhibition">
            <div className="cont_title"><span>服务中心图片</span></div>
            <div className="cityServe_content">
              <div className="cityServe_content_left_btn"></div>
              <div className="cityServe_content_right_btn"></div>
              <div className="cityServe_content_slideshow clear">
                <Slider {...settings}>
                  <a className="cityServe_content_slideshow_link" href='#' style={{ cursor: "pointer" }}>
                    <div className="cityServe_content_slideshow_img">
                      <img src={serviceCenterImg01} />
                    </div>
                  </a>
                  <a className="cityServe_content_slideshow_link" href='#' style={{ cursor: "pointer" }}>
                    <div className="cityServe_content_slideshow_img">
                      <img src={serviceCenterImg02} />
                    </div>
                  </a>
                  <a className="cityServe_content_slideshow_link" href='#' style={{ cursor: "pointer" }}>
                    <div className="cityServe_content_slideshow_img">
                      <img src={serviceCenterImg03} />
                    </div>
                  </a>
                  <a className="cityServe_content_slideshow_link" href='#' style={{ cursor: "pointer" }}>
                    <div className="cityServe_content_slideshow_img">
                      <img src={serviceCenterImg04} />
                    </div>
                  </a>
                  <a className="cityServe_content_slideshow_link" href='#' style={{ cursor: "pointer" }}>
                    <div className="cityServe_content_slideshow_img">
                      <img src={serviceCenterImg01} />
                    </div>
                  </a>
                </Slider>
              </div>
            </div>
          </div>

        </div>








      </div >
    );
  }
}
